import { ActivityItemType } from "@app/courses/models/activity-item-type";

export class DeletionResult{
    hasBeenProcessed : boolean;
    isDeleted :boolean;
    constructor (public uri: string, public moduleId: number, public type?: ActivityItemType, public sectionId?: number){
    }
}